// extracted by mini-css-extract-plugin
export default {"SidebarNavList":"SidebarNavListL_X4qPkzkRPm","SidebarNavListItem":"SidebarNavListItemycfFc4AJumxI"};